import useResizeObserver from '@react-hook/resize-observer';
import { useState, useLayoutEffect } from 'react';

/*

Due to rounding, `scrollWidth` and `clientWidth` do not always accurately represent whether overflow has occurred.
        Reproduction: https://codesandbox.io/s/determined-cartwright-9j21gm?file=/src/App.js
        Issue: https://github.com/w3c/csswg-drafts/issues/4123
        
*/
const useIsTruncated = target => {
  const [isTruncated, setIsTruncated] = useState(false);
  useLayoutEffect(() => {
    if (!target) {
      return;
    }
    const {
      clientWidth,
      scrollWidth
    } = target.current;

    // set initial value
    setIsTruncated(clientWidth < scrollWidth);
  }, [target]);
  useResizeObserver(target, entry => {
    if (!target) {
      return;
    }
    const {
      clientWidth,
      scrollWidth
    } = entry.target;

    // update value on resize
    setIsTruncated(clientWidth < scrollWidth);
  });
  return isTruncated;
};

export { useIsTruncated as default };
